import { toolTypes } from "../../../constants";
import rough from "roughjs/bundled/rough.esm";

const generator = rough.generator();

const generateRectangle = ({ x1, y1, x2, y2 }) => {
	return generator.rectangle(x1, y1, x2 - x1, y2 - y1);
};

const generateCircle = ({ x1, y1, x2, y2 }) => {
	return generator.ellipse(x1, y1, x2 - x1, y2 - y1);
};

const generateLine = ({ x1, y1, x2, y2 }) => {
	return generator.line(x1, y1, x2, y2);
};

export const createElement = ({
	x1,
	y1,
	x2,
	y2,
	toolType,
	id,
	text,
	order,
}) => {
	let roughElement;

	switch (toolType) {
		case toolTypes.RECTANGLE:
			roughElement = generateRectangle({ x1, y1, x2, y2 });
			return {
				id: id,
				roughElement,
				type: toolType,
				x1,
				y1,
				x2,
				y2,
				order,
				revision: 1,
			};
		case toolTypes.CIRCLE:
			roughElement = generateCircle({ x1, y1, x2, y2 });
			return {
				id: id,
				roughElement,
				type: toolType,
				x1,
				y1,
				x2,
				y2,
				order,
				revision: 1,
			};
		case toolTypes.LINE:
			roughElement = generateLine({ x1, x2, y1, y2 });
			return {
				id: id,
				roughElement,
				type: toolType,
				x1,
				y1,
				x2,
				y2,
				order,
				revision: 1,
			};
		case toolTypes.PENCIL:
			return {
				id,
				type: toolType,
				points: [{ x: x1, y: y1 }],
				order,
				revision: 1,
			};
		case toolTypes.TEXT:
			return {
				id,
				type: toolType,
				x1,
				y1,
				text: text,
				order,
				revision: 1,
			};
		case toolTypes.ERASER:
			return {
				id,
				type: toolType,
				points: [{ x: x1, y: y1 }],
				order,
				revision: 1,
			};
		default:
			throw new Error("Something went wrong when creating element");
	}
};
